import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';
import { setCurrentWorkspaceModelsIds } from '../slices/currentWorkspace';
import { setModels } from '../slices/models';

export const getModelsByWorkspace = createAsyncThunk(
  'models/getModelsByWorkspace',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      setLoading(true);
      try {
        const models = await api.workspace.getModelsByWorkspaceId({
          workspaceId,
        });

        if (models.data.getModelsByWorkspaceId?.models) {
          dispatch(setModels(models.data.getModelsByWorkspaceId.models));

          dispatch(
            setCurrentWorkspaceModelsIds(
              models.data.getModelsByWorkspaceId.models.map((model) => model.id)
            )
          );
        }
        setLoading(false);
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
      }
    } else {
      setErrors('generalError');
      setLoading(false);
    }
  }
);

export const createModel = createAsyncThunk(
  'models/createModel',
  async (data) => {
    const modelCreated = await api.model.createModel({
      data,
    });

    return modelCreated.data.createModel;
  }
);

export const updateModelById = createAsyncThunk(
  'models/updateModelById',
  async (payload) => {
    const { id, data } = payload;
    const modelUpdated = await api.model.updateModelById({
      id,
      data,
    });

    return modelUpdated.data.updateModelById;
  }
);

export const deleteModelById = createAsyncThunk(
  'models/deleteModelById',
  async (payload) => {
    const modelDeleted = await api.model.deleteModelById({ id: payload });

    return modelDeleted.data.deleteModelById;
  }
);
